import { rest } from 'msw';
import {
  existedHostname,
  existedCompanyname,
  exceptionCausingName,
  existedEmail,
  testInstanceUrl,
  timeoutCausingName,
  triggerCompleteSignup409,
  registrationIdForHappyPath,
  registrationIdForPollingTimeout,
  pollingTimeoutCausingName,
  invalidPassword,
} from './constants';

export const handlers = [
  rest.get(`/xm/free/shared/api/companyName/:companyName`, (req, res, ctx) => {
    const { companyName } = req.params;
    if (companyName === existedCompanyname) {
      return res(ctx.status(200));
    }

    if (companyName === exceptionCausingName) {
      return res(ctx.status(503));
    }

    return res(ctx.status(404));
  }),

  rest.post('/xm/free/shared/api/signup', (req, res, ctx) => {
    if (req.body.firstName === exceptionCausingName) {
      return res(ctx.status(500));
    }

    if (req.body.emailAddress === existedEmail) {
      return res(ctx.status(409));
    }

    return res(
      ctx.status(202),
      ctx.json({
        token: '1234',
      }),
    );
  }),

  rest.post('/xm/free/api/registration', (req, res, ctx) => {
    if (req.body.firstName === exceptionCausingName) {
      return res(ctx.status(500));
    }

    if (req.body.email === existedEmail) {
      return res(ctx.status(409));
    }

    const registrationId =
      req.body.firstName === pollingTimeoutCausingName
        ? registrationIdForPollingTimeout
        : registrationIdForHappyPath;

    return res((res) => {
      res.headers.set(
        'Location',
        `/xm/free/api/registration/${registrationId}`,
      );
      res.status = 201;
      return res;
    });
  }),

  rest.get(`/xm/free/shared/api/hostname/:hostname`, (req, res, ctx) => {
    const { hostname } = req.params;
    if (hostname === existedHostname) {
      return res(ctx.status(200));
    }

    if (hostname === exceptionCausingName) {
      return res(ctx.status(503));
    }

    if (/^[A-Za-z0-9]+(-[A-Za-z0-9]+)*$/.test(hostname)) {
      return res(ctx.status(404));
    }

    return res(ctx.status(400));
  }),

  rest.head(`/xm/free/api/availability/:hostname`, (req, res, ctx) => {
    const { hostname } = req.params;
    if (hostname === existedHostname) {
      return res(ctx.status(204));
    }

    if (hostname === exceptionCausingName) {
      return res(ctx.status(503));
    }

    if (/^[A-Za-z0-9]+(-[A-Za-z0-9]+)*$/.test(hostname)) {
      return res(ctx.status(200));
    }

    return res(ctx.status(400));
  }),

  rest.post('/xm/free/shared/api/completeSignup', (req, res, ctx) => {
    if (req.body.password === exceptionCausingName) {
      return res(ctx.status(500));
    }

    if (req.body.hostnamePrefix === timeoutCausingName) {
      return res(ctx.status(408));
    }

    if (req.body.hostnamePrefix === triggerCompleteSignup409) {
      return res(ctx.status(409));
    }

    return res((res) => {
      res.headers.set(
        'Location',
        `https://${req.body.hostnamePrefix}.dev.xmatters.com`,
      );
      res.status = 200;
      return res;
    });
  }),

  rest.post('/xm/free/api/registration/:registrationId', (req, res, ctx) => {
    if (req.body.password === exceptionCausingName) {
      return res(ctx.status(503));
    }

    if (req.body.hostnamePrefix === triggerCompleteSignup409) {
      return res(ctx.status(409));
    }

    return res(ctx.status(202));
  }),

  rest.get('/xm/free/api/registration/:registrationId', (req, res, ctx) => {
    const registrationId = req.params.registrationId;
    const status =
      registrationId === registrationIdForHappyPath
        ? 'PROVISIONED'
        : 'ACCEPTED_FOR_PROVISIONING';
    const redirectURL =
      registrationId === registrationIdForHappyPath ? testInstanceUrl : '';
    return res(
      ctx.status(200),
      ctx.json({
        status,
        redirectURL,
      }),
    );
  }),

  rest.get(`${testInstanceUrl}/ping`, (req, res, ctx) => {
    return res(ctx.status(200));
  }),

  rest.post('/xm/free/api/password/validate', (req, res, ctx) => {
    if (req.body.password === invalidPassword) {
      return res(
        ctx.status(200),
        ctx.json({
          dictionaryMatchingPassed: true,
          noLeadingOrTrailingSpacesPassed: false,
          passwordMaximumLengthPassed: true,
          passwordMinimumLengthPassed: true,
          requiresLowercaseLetterPassed: true,
          requiresSpecialCharacterPassed: true,
          requiresUppercaseLetterPassed: false,
        }),
      );
    }
    return res(
      ctx.status(200),
      ctx.json({
        dictionaryMatchingPassed: true,
        noLeadingOrTrailingSpacesPassed: true,
        passwordMinimumLengthPassed: true,
        passwordMaximumLengthPassed: true,
        requiresUppercaseLetterPassed: true,
        requiresLowercaseLetterPassed: true,
        requiresSpecialCharacterPassed: true,
      }),
    );
  }),

  rest.get('/xm/free/api/password/policy', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        dictionaryMatching: true,
        passwordMinimumLength: 8,
        requiresUppercaseLetter: true,
        requiresLowercaseLetter: true,
        requiresSpecialCharacter: true,
        noLeadingOrTrailingSpaces: true,
        passwordMaximumLength: 100,
      }),
    );
  }),
];
